import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    myMessages: [],
    signalRStatus: "Disconnected",
    currentUserId: null
};

const messageSlice = createSlice({
    name: "message",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        setMessageData: (state, action) => {
            Object.assign(state, action.payload);
        },
        addMessage: (state, action) => {
            state.myMessages.push({
                ...action.payload,
                clientTimestamp: action.payload.clientTimestamp ?? Date.now()
            });
        },
        setSignalRStatus: (state, action) => {
            state.signalRStatus = action.payload;
        },
        setCurrentUserId: (state, action) => {
            state.currentUserId = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setValue,
    setMessageData,
    setSignalRStatus,
    setCurrentUserId,
    setLoading,
    addMessage
} = messageSlice.actions;
export default messageSlice.reducer;
